import Dashboard from './components/Dashboard';
import Profile from './components/Profile';
import Login from './components/Login';
import ProfileNew from './components/ProfileNew';
import SubForm from './components/SubForm';
import IsoReply from './components/public/IsoReply';
import AcceptedOffer from './components/AcceptedOffer';
import RejectOfferForm from './components/RejectOfferForm';

const routes = [
    { 
        path: '/', 
        redirect: () => {
            return '/login';
        },
    },
    { path: '/dashboard', name: "Dashboard", component: Dashboard },
    { path: '/profile', name: "Profile", component: Profile },
    // { path: '/subform', name: "SubForm", component: SubForm },
    { path: '/iso/accept_offer', name: "AcceptedOffer", component: AcceptedOffer },
    { path: '/iso/reject_offer', name: "RejectOfferForm", component: RejectOfferForm },
    // { path: '/subform/:iso_id/:user_id', name: "SubForm", component: SubForm },
    // { path: '/iso/accept_offer/:iso_id/:user_id', name: "AcceptedOffer", component: AcceptedOffer },
    { path: '/login', name: "Login", component: Login },
    { path: '/profile-new', name: "ProfileNew", component: ProfileNew },
    { path: '/iso_email_reply/:iso_id/:user_id', name: "ProfileNew", component: IsoReply },
];

export default routes;